// extracted by mini-css-extract-plugin
export var dottedBorder = "cart-module--dottedBorder--uzbxm";